<template>
  <header
    class="navbar-question"
    :class="{ 'navbar-question--dark-mode': darkMode }"
  >
    <img class="navbar-question__logo" :src="logo" alt="" />
    <div class="cancel-resp" v-if="cancel" @click="$emit('cancel')">
      <feather class="cancel-resp__icon" type="x" :size="size" />
    </div>
  </header>
</template>

<script>
export default {
  name: "VNavbar",
  props: {
    logo: {
      type: String,
      default: ""
    },
    darkMode: Boolean,
    cancel: Boolean
  },
  computed: {
    size() {
      return this.smallScreenAndDown ? 24 : 48;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.navbar-question {
  padding: 24px 48px;
  margin: 0 -24px;
  background: #fff;
  display: flex;
  justify-content: center;
  box-shadow: 0px 8px 8px rgba(036, 36, 36, 0.2);
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9999;

  &--dark-mode {
    background: #000;
  }

  &__logo {
    max-height: 112px;

    @media #{$small-and-down} {
      max-height: 56px;
    }
  }
}

.cancel-resp {
  position: fixed;
  right: 16px;
  height: 64px;
  top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  border-radius: 50%;

  @media #{$small-and-down} {
    height: 48px;
    width: 48px;

    &__icon {
      width: 32px;
    }
  }

  &__icon {
    color: #ffbb3c;
  }
}
</style>
